import { CAS } from "thrive-chat";
import localisation from "../services/localisation";
import * as webappHttpService from "../services/http";
import IL from "../interfaces/localisation";


function getChatlocalisation() {
    return {
        NoConversations: () =>  localisation.getLocalString(IL['Chat.NoConversations']),
        WriteAMessage: () => localisation.getLocalString(IL['Chat.WriteAMessage']),
        NewChat: () => localisation.getLocalString(IL['Chat.NewChat']),
        SendMessage: () => localisation.getLocalString(IL['Chat.SendMessage']),
        YourMessageCouldNotBeDelivered: () =>  localisation.getLocalString(IL['Chat.YourMessageCouldNotBeDelivered']),
        SearchByNameOrJobRole: () => localisation.getLocalString(IL['PeopleDirectory.SearchForNameJob']),
        Search: () => localisation.getLocalString(IL['General.Search']),
        SearchPeopleCount: (count: number) => localisation.getLocalString(IL['PeopleDirectory.XPeople'], [String(count)]),
        NoSearchPeopleResults: (searchTerm: string) => localisation.getLocalString(IL['PeopleDirectory.NoResultsForX'], [searchTerm]),
        SearchPeopleResults: (count: number, searchTerm: string) => localisation.getLocalString(IL['PeopleDirectory.ShowingXResultsFor'], [String(count), searchTerm]),
        You: (message: string) => localisation.getLocalString(IL['Chat.YouConcat'], [message]),
        SelectAConversationOrStartANewChat: () => localisation.getLocalString(IL['Chat.SelectAConversationOrStartANewChat'])
    }
} 

const appInit = {

    setup:async function(){

        // Localisation
        localisation.setup();
        // initialise chat
        CAS.init({
            httpClient: webappHttpService,
            localisationStrings: getChatlocalisation()
        })

        return
    }
}

export default appInit;